﻿import * as $ from "jquery";

import { collapseSearchResult } from "./hittaDocumentSearchUtil";


$.widget("hittaSearch.MellanarkivetSearchPage",
    {
        _init: function () {
            collapseSearchResult("hittaiarkivet");
            this._showResetButton();
            this._filterOptionReset();
        },
        _showResetButton: function () {
            $(".reset").removeClass("hidden");
        },
        _filterOptionReset: function () {
            var self = this;
            $(".reset").click(function () {
                // Select all filter options and reset their values
                $(".select", self.element).val("");

                // $(this)._submitForm();
                //this.submitForm();
                var $form = $("#search-form");
                $form.submit();
            });
        },
    }
);

(function ($, hittaSearch) {
    var $searchPage = $("#hittaiarkivet-search-page");
    if ($searchPage.length > 0) {
        // Execute widget
        $searchPage.MellanarkivetSearchPage();
    }
})($);
